import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import Button from "../../components/inputs/Button";
import TabButton from "../../components/inputs/TabButton";
import MessageBox from "../../components/utils/MessageBox";
import PlanCard from "../../components/cards/PlanCard";
import api from "../../components/api";

const ManageSubscriptionPage = ({ mobile, height, setUser, user }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [showCancelSubscriptionMsgBox, setShowCancelSubscriptionMsgBox] = useState(false);
  const [showActivateSubscriptionMsgBox, setShowActivateSubscriptionMsgBox] = useState(false);

  useEffect(() => {
    setUser((prev) => ({ ...prev, subscription }));
  }, [subscription, setUser]);

  const cancelSubscription = () => {
    setLoading(true);
    api.cancelSubscription(
      (response) => {
        setLoading(false);
        window.location.reload();
      },
      (error) => {
        setLoading(false);
        console.log(error);
      }
    );
  };

  const activateSubscription = () => {
    setLoading(true);
    api.activateSubscription(
      (response) => {
        setLoading(false);
        window.location.reload();
      },
      (error) => {
        setLoading(false);
        console.log(error);
      }
    );
  };

  const getSubscription = async () => {
    setLoading(true);
    api.getSelfSubscription(
      (response) => {
        setSubscription(response);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getSubscription();
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const formatNumberWithDots = (number) => {
    const numberString = number.toString();
    const parts = [];
    for (let i = numberString.length - 1; i >= 0; i -= 3) {
      const part = numberString.substring(Math.max(0, i - 2), i + 1);
      parts.unshift(part);
    }
    return parts.join(".");
  };

  return (
    <Box
      sx={{
        height,
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0px 10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {mobile > 0 && (
        <MobileTopBar showBack onBack={() => navigate("/perfil")}>
          Gestionar Subscripción
        </MobileTopBar>
      )}
      <Box
        style={{
          maxWidth: "700px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        {loading && (
          <Typography
            style={{
              width: "100%",
              textAlign: "center",
              color: "#ffffff",
              fontWeight: "500",
              fontSize: "20px",
              marginLeft: "10px",
              marginTop: "10px",
            }}
          >
            Cargando...
          </Typography>
        )}
        {showCancelSubscriptionMsgBox && (
          <MessageBox
            acceptText="Si, dar de baja"
            cancelText="Cancelar"
            onAccept={() => cancelSubscription()}
            onCancel={() => setShowCancelSubscriptionMsgBox(false)}
          >
            <Typography
              style={{
                fontWeight: "600",
                fontSize: "36px",
                color: "white",
                textAlign: "center",
                paddingTop: "30px",
              }}
            >
              ¿Estás seguro de dar de baja la membresía?
            </Typography>
          </MessageBox>
        )}
        {showActivateSubscriptionMsgBox && (
          <MessageBox
            acceptText="Si, dar de alta"
            cancelText="Cancelar"
            onAccept={() => activateSubscription()}
            onCancel={() => setShowActivateSubscriptionMsgBox(false)}
          >
            <Typography
              style={{
                fontWeight: "600",
                fontSize: "36px",
                color: "white",
                textAlign: "center",
                paddingTop: "30px",
              }}
            >
              ¿Estás seguro de dar de alta la membresía?
            </Typography>
          </MessageBox>
        )}
        {!loading && (
          <>
            <Typography
              style={{
                width: "100%",
                textAlign: "center",
                color: "#ffffff",
                fontWeight: "500",
                fontSize: "20px",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Plan actual
            </Typography>

            <PlanCard
              planName={user.plan.name}
              planDescription={user.plan.description}
              planPrice={`$${formatNumberWithDots(user.plan.price)} /mes`}
              selected
            />
            <Typography
              style={{
                width: "100%",
                textAlign: "center",
                color: user.subscriptionExpire > new Date().toISOString() ? "#ffffff" : "#FF1F01",
                fontWeight: "500",
                fontSize: "20px",
                marginLeft: "10px",
                marginBottom: "15px",
              }}
            >
              {user.subscriptionExpire > new Date().toISOString() ? "Vigente hasta el " : "Venció el "}
              {formatDate(user.subscriptionExpire)}
            </Typography>

            <TabButton
              sx={{ maxWidth: "700px" }}
              onClick={() => {
                const msg = `Hola, quiero modificar el plan de mi suscripción. Mi plan actual es ${user.plan.name}. Mi DNI es ${user.dni}. Muchas gracias.`;
                window.open(
                  `https://api.whatsapp.com/send/?phone=541151330870&text=${msg}&type=phone_number&app_absent=0`
                );
              }}
            >
              Cambiar plan
            </TabButton>
            <TabButton sx={{ maxWidth: "700px" }} onClick={() => navigate("/pagos/tarjeta")}>
              Actualizar tarjeta de crédito
            </TabButton>
            <TabButton sx={{ maxWidth: "700px" }} onClick={() => navigate("/pagos/historial")}>
              Historial de pagos
            </TabButton>
            {subscription?.status === "CANCELLED" && (
              <Typography
                style={{
                  width: "100%",
                  textAlign: "center",
                  color: "red",
                  fontWeight: "500",
                  fontSize: "20px",
                  marginLeft: "10px",
                }}
              >
                Subscripción cancelada
              </Typography>
            )}

            {subscription?.status !== "CANCELLED" && (
              <Button
                stroked
                sx={{ maxWidth: "700px", marginTop: "10px" }}
                onClick={() => setShowCancelSubscriptionMsgBox(true)}
              >
                Dar de baja la subscripción
              </Button>
            )}
            {subscription?.status === "CANCELLED" && (
              <Button
                sx={{ maxWidth: "700px", marginTop: "10px" }}
                onClick={() => setShowActivateSubscriptionMsgBox(true)}
              >
                Dar de alta la subscripción
              </Button>
            )}
          </>
        )}

        {mobile > 0 && (
          <div
            style={{
              width: "100%",
              height: "70px",
              color: "rgba(0,0,0,0)",
            }}
          >
            -
          </div>
        )}
      </Box>
    </Box>
  );
};

export default ManageSubscriptionPage;
